import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { AngularFireAuth } from 'angularfire2/auth';
import { UserService } from './user.service';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import * as firebase from 'firebase';


@Injectable()
export class DatabaseService {

    constructor(public userService : UserService){}

    /* --------------------------- */
    /*          Leave              */
    /* --------------------------- */
    //Create
    public createLeave(data) {
        let userId = this.userService.getCurrentUserId();
        let path = 'leave/' + userId + '/';

        let database = firebase.database();
        let databaseRef = database.ref();
        let leaveRef = databaseRef.child(path);

        
        // Generate a reference to a new location and add some data using push()
        var newLeaveRef = leaveRef.push(data);

        // Get the unique key generated by push()
        var leaveId = newLeaveRef.key;
    }

    //Read

    //Update

    //Delete

    /* --------------------------- */
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/services/database.service.ts